import { Input } from 'antd';
import './TextInputStyle.css';

//takes an onChange prop and calls it with (dataKey, newValue)
const TextInput = (props) => {
    const { def, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";
    const minLengthWarning = `"${def.label}" must be at least ${def.minLength} characters`;

    const checkText = (value) => {
        if (state.required || value.length > 0) {
            if (value.length > def.maxLength && !err) return;
            else if (value.length > def.maxLength) {
                onChange(def.dataKey, value, warning);
            }
            else if (value.length < def.minLength) {
                onChange(def.dataKey, value, minLengthWarning);
            }
            else {
                onChange(def.dataKey, value);
            }
        }
        else {
            onChange(def.dataKey, value);
        }
    }

    return <Input
        id={def.dataKey}
        data-input={'textinput_de'}
        className={'basicinput_de'}
        status={err}
        readOnly={state.readonly}
        disabled={state.readonly}
        value={data}
        onChange={ev => checkText(ev.target.value)}
        placeholder={def.placeholder}
    />
};

export default TextInput;
